import { EuiPageTemplate, EuiButton } from "@inscopix/ideas-eui";

interface CreatePersonalSpaceRetryProps {
  onRetryCreate: () => Promise<void>;
  isRetryLoading: boolean;
}

export const CreatePersonalSpaceRetry = ({
  onRetryCreate,
  isRetryLoading,
}: CreatePersonalSpaceRetryProps) => {
  return (
    <EuiPageTemplate.EmptyPrompt
      title={<span>Create your personal space</span>}
      iconType={"spacesApp"}
      footer={
        <EuiButton
          fill
          onClick={() => {
            void onRetryCreate();
          }}
          isLoading={isRetryLoading}
        >
          Create
        </EuiButton>
      }
    >
      We have your answers saved already, so you can create your personal space
      right away! Click the button below to get started.
    </EuiPageTemplate.EmptyPrompt>
  );
};
